import { Grid, Skeleton } from "@mui/material";

const SkeletonInvoiceForm = () => {
  return (
    <Grid item sx={{ mt: 3 }}>
      <Skeleton animation="wave" width="100%" height="50px" />
      <Skeleton animation="wave" width="100%" height="50px" />
      <Skeleton
        animation="wave"
        width="100%"
        height="400px"
        sx={{ mt: -10, mb: -8 }}
      />
      <Skeleton animation="wave" width="100%" height="80px" />
    </Grid>
  );
};

export default SkeletonInvoiceForm;
